// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3R2ip","itemTitle":"ClientEmergencyInfo_itemTitle__2-5wK","itemText":"ClientEmergencyInfo_itemText__2l1o8"};